import { HouseDetail } from '@f-fertighaus/applications/Next/types/houseDetailsResponse'
import { useUserPostcode } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/useUserPostcode'

export const useSimilarHousesSearchParam = (data: HouseDetail) => {
  const postcode = useUserPostcode()
  let searchParams = ''

  if (postcode) {
    searchParams = searchParams.concat('delivery_regions__in', '=', postcode)
  }

  if (data.price) {
    const housePriceRoundedTo10k = Math.floor(data.price / 10_000) * 10_000
    const housePriceRangeAbove400k = [
      housePriceRoundedTo10k - 100_000,
      housePriceRoundedTo10k + 100_000
    ]
    const housePriceRangeBelow400k = [
      housePriceRoundedTo10k - 50_000,
      housePriceRoundedTo10k + 50_000
    ]
    const dataPriceRange =
      data.price > 400_000 ? housePriceRangeAbove400k : housePriceRangeBelow400k

    searchParams = searchParams.concat(
      'price__range',
      '=',
      dataPriceRange.join(',')
    )
  }

  if (data.form) {
    searchParams = searchParams.concat(
      '&',
      'form__in',
      '=',
      data.form.toString()
    )
  }

  if (data.living_area_total) {
    const livingAreaTotalRoundedTo5 = Math.floor(data.living_area_total / 5) * 5
    const livingAreaTotalRangeAbove200squareMeters = [
      livingAreaTotalRoundedTo5 - 30,
      livingAreaTotalRoundedTo5 + 30
    ]
    const livingAreaTotalRangeBelow200squareMeters = [
      livingAreaTotalRoundedTo5 - 30,
      livingAreaTotalRoundedTo5 + 30
    ]
    const houseLivingAreaRange =
      livingAreaTotalRoundedTo5 > 200
        ? livingAreaTotalRangeAbove200squareMeters
        : livingAreaTotalRangeBelow200squareMeters
    searchParams = searchParams.concat(
      '&',
      'living_area_total__range',
      '=',
      houseLivingAreaRange.join(',')
    )
  }

  if (data.utilization) {
    searchParams = searchParams.concat(
      '&',
      'utilization',
      '=',
      data.utilization.toString()
    )
  }

  return searchParams
}
